import React from 'react';

/**
 * The Visma wordmark, positive (one colour, the text colour) for light backgrounds:
 * the path visma.com draws. Visma's logo rules: black on light, white on dark or
 * colour; never on the gradient, never multicolour or outlined. The footer used to put
 * it on a purple-to-orange tile, which spent the page's one gradient on the footer.
 * Text alternative: "Visma".
 */
export default function VismaLogo({ height = 16, className }: { height?: number; className?: string }) {
  return (
    <svg
      className={className}
      role="img"
      aria-label="Visma"
      viewBox="0 0 740 202"
      height={height}
      width={(height * 740) / 202}
      fill="currentColor"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0,0h47.31l31.73,155.01h.84L111.32,0h47.87l-47.31,201.77H47.31L0,0h0ZM180.22,0h45.36v201.77h-45.36V0h0ZM294.2,154.74c0-11.13-3.9-21.15-10.85-32.56l-14.75-23.93c-11.13-18.09-16.42-31.45-16.42-46.76,0-21.43,8.07-39.8,19.48-51.49h50.09c-15.03,11.97-24.21,29.5-24.21,47.03,0,11.13,3.9,21.15,10.85,32.56l14.75,23.93c11.13,18.09,16.42,31.45,16.42,46.76,0,21.43-8.07,39.8-19.48,51.49h-50.09c13.36-11.97,24.21-29.5,24.21-47.03ZM366.16,0h73.47l23.38,121.34h.83L484.71,0h74.86v201.77h-44.81V46.76h-.83l-33.12,155.01h-35.9l-33.12-155.01h-.84v155.01h-44.81V0h0ZM627.92,0h64.57l47.31,201.77h-47.31l-31.73-155.01h-.83l-31.45,155.01h-47.87L627.92,0h0Z" />
    </svg>
  );
}
